import { useEffect } from 'react';
import { Step } from 'shared/InstallationDialog';
import { buildDisplayManifestJson } from 'shared/InstallationDialog/utils/manifest';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { spawn } from 'utils/translations';
import { CodeBlock } from '../../CodeBlock';
import { Loader } from '../../Loader';
import { useGithubInstallation } from '../githubInstallationContext';
import { getManifestJson } from '../utils';

export const ReviewManifest = () => {
  const { setIsNextEnabled } = useMultiStepDialog();
  const { organizationUrl, webhookUrl, isWebhookUrlLoading } =
    useGithubInstallation();

  const spawnManifest = spawn('dialogs.github-installation.review-manifest');

  const manifestJson = isWebhookUrlLoading
    ? undefined
    : getManifestJson(organizationUrl, webhookUrl);

  useEffect(() => {
    setIsNextEnabled(!!manifestJson);
  }, [manifestJson, setIsNextEnabled]);

  const renderManifest = () => {
    if (!manifestJson) {
      return (
        <div className="flex items-center justify-center py-8">
          <Loader />
        </div>
      );
    }

    const displayJson = buildDisplayManifestJson(manifestJson) ?? manifestJson;

    return (
      <CodeBlock
        rawCode={manifestJson}
        displayCode={displayJson}
        copyTitle={spawnManifest('copy-title')}
      />
    );
  };

  return (
    <Step
      title={spawnManifest('title')}
      description={spawnManifest('description')}
    >
      {renderManifest()}
    </Step>
  );
};
